<template>
  <div>
    <!-- PC/移动端导航（保持原有逻辑） -->
    <PCNavbar selectIndex="1-1"  style="background: #ececec;"/>
    <MobileNavBar :currentActive="1" />

    <!-- 核心：根据flag渲染对应组件，增加默认兜底 -->
    <div class="content-wrapper">
      <!-- 公司简介 -->
      <CompanyProfile v-if="flag === 'com'" />
      <!-- 董事长简介 -->
      <ChairmansProfile v-if="flag === 'chairmans'" />
      <!-- 公司大事件 -->
      <MajorEvent v-if="flag === 'majorEvent'" />
      <!-- 非法参数兜底提示 -->
      <div class="empty-tip" v-if="!flag">
        暂无相关内容，请返回重试
      </div>
    </div>

    <!-- 页脚 -->
    <Footer />
  </div>
</template>

<script>
// 优化：组件懒加载（减少首屏打包体积）
import PCNavbar from '@/views/home/navbar/indexDetail.vue'
import MobileNavBar from '@/views/home/navbar/MobileNavBar.vue'
import Footer from '@/views/home/callme/footerIndex.vue'
const CompanyProfile = () => import('@/views/business/company/companyProfile.vue')
const ChairmansProfile = () => import('@/views/business/company/chairmansProfile.vue')
const MajorEvent = () => import('@/views/business/company/majorEvent.vue')

export default {
  name: 'CompanyCenter', // 增加组件名
  components: {
    PCNavbar,
    MobileNavBar,
    Footer,
    CompanyProfile,
    ChairmansProfile,
    MajorEvent
  },
  data() {
    return {
      flag: '',
    }
  },
  created() {
    // 初始化获取路由参数
    this.updateFlagFromRoute()
  },
  watch: {
    // 关键：监听路由参数变化，实时更新flag（解决参数变化页面不刷新问题）
    '$route.query.flag': {
      immediate: true, // 初始化时也执行
      handler() {
        this.updateFlagFromRoute()
      }
    }
  },
  methods: {
    // 统一更新flag的方法（复用性更高）
    updateFlagFromRoute() {
      const routeFlag = this.$route.query.flag || ''
      this.flag = routeFlag.trim() // 去除首尾空格，避免参数异常
    }
  }
}
</script>

<style scoped lang="scss">
.empty-tip {
  text-align: center;
  padding: 100px 0;
  color: #999;
  font-size: 16px;
}
</style>